module.exports = __webpack_public_path__ + "img/tr.4dd4b60c.svg";